<app-campaign-details [user]="user" [campaign]="campaign"></app-campaign-details>
<app-campaign-profile [profile]="campaign" *ngIf="isStudentMigrated !== true"></app-campaign-profile>
<!-- <p-growl [(value)]="msgs" life=5000></p-growl> -->
 <div class="link-expire-wrapper" *ngIf="isStudentMigrated === true">
    <span translate>lbl_student_migrated</span>
 </div>